/**
 * 个人信息 - api
 * date:2022 04 23
 * author:brian
 */

import httpRequest from '@/utils/request.js';

/**获取个人信息数据 */
export const mineMe = (params = {}) => httpRequest.httpGet({
    url: '/service/mine/me', params: {
        ...params
    }
})
/**获取资源信息数据 */
export const mineResource = (params = {}) => httpRequest.httpGet({
    url: '/service/mine/resource', params: {
        ...params
    }
})
/**修改个人资料 */
export const minePersonal = (data) => httpRequest.httpPut('/service/mine/personal', data)
/**修改密码 */
export const minePassword = (data) => httpRequest.httpPut('/service/mine/password', data)
/**开启或者关闭 */
export const mineGuide = (data = {}) => httpRequest.httpPut('/service/mine/guide?on=' + data.on)
/**上传头像 */
export const mineUpload = (data = {}) => httpRequest.httpPost('/service/mine/upload',data)
/**获取头像 */
export const mineAvatar = (params = {}) => httpRequest.httpGet({
    url: '/service/mine/avatar', params: {
        ...params
    }
})

/**保存单位设置 */
export const saveUnitSetting = (data) => httpRequest.httpPost('/service/mine/unit/setting/save', data)


/**获取单位设置 */
export const getUnitSetting = (params = {}) => httpRequest.httpGet({
  url: '/service/mine/unit/setting/get', params: {
    ...params
  }
})

/** 发起邮箱修改（验证密码，发送验证码到新邮箱） */
export const mineEmailChange = (data) => httpRequest.httpPost('/service/mine/email/change', data)

/** 验证邮箱验证码并完成修改 */
export const mineEmailVerify = (data) => httpRequest.httpPost('/service/mine/email/verify', data)

/** 重发邮箱验证码 */
export const mineEmailResend = (data) => httpRequest.httpPost('/service/mine/email/resend', data)

/** 申请企业账号（个人账号升级） */
export const mineApplyEnterprise = (data) => httpRequest.httpPost('/service/mine/apply-enterprise', data)
